<template>
  <div class="Role-container">
    <!--检索部分-->
    <div style="margin: 10px 0">
      <el-input style="width: 200px;" placeholder="请输入角色名称"
                v-model="send.name"></el-input>
      <el-input style="width: 200px;" placeholder="请输入角色描述"
                v-model="send.des"
                class="ml-10"></el-input>
      <el-button class="ml-10" type="primary" @click="selectListPage">
        搜索<i class="el-icon-search"></i>
      </el-button>
      <el-button type="warning" @click="reset">
        重置<i class="el-icon-refresh"></i>
      </el-button>
      <!--检索部分结束-->

      <!--新增与删除-->
      <el-button type="primary" @click="insertWindow">新增<i class="el-icon-circle-plus-outline"></i>
      </el-button>
      <el-popconfirm
          class="ml-10"
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="确认要批量删除吗？"
          @confirm="confirmRemoveIdList">
        <el-button type="danger" slot="reference">批量删除<i
            class="el-icon-remove-outline"></i>
        </el-button>
      </el-popconfirm>
      <el-upload style="display: inline-block"
                 :action="'https://'+WHITE_IP+'/role/list_import'"
                 name="multipartFile"
                 :show-file-list="false"
                 accept="xlsx"
                 :on-success="onImportSuccess">
        <!-- <el-button type="primary" class="ml-10">导入<i class="el-icon-upload2"></i></el-button>-->
      </el-upload>
      <el-button type="primary" class="ml-10" @click="list_export">导出<i class="el-icon-download"></i></el-button>
    </div>


    <!--表格部分-->
    <el-table :data="list" boder stripe
              :header-cell-style="{'text-align':'center'}"
              :cell-style="{'text-align':'center'}"
              border
              width="220"
              @selection-change="onSelectChange"
              :header-cell-class-name="headerBg">
      <el-table-column type="selection" width="60"></el-table-column><!--选择框-->
      <!--      <el-table-column prop="id" label="ID"></el-table-column>-->
      <el-table-column type="index" :index="hIndex" label="序号" width="80"/>

      <el-table-column prop="name" label="角色名称"></el-table-column>

      <el-table-column prop="des" label="角色描述"></el-table-column>

      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="info" slot="reference" @click="giveMenu(scope.row)">分配<i
              class="el-icon-menu"></i></el-button>
          <el-button type="success" @click="updateWindow(scope.row)">编辑<i
              class="el-icon-edit"></i></el-button>
          <el-popconfirm
              class="ml-10"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="确认要删除吗？"
              @confirm="confirmDelete(scope.row.id)">
            <el-button type="danger" slot="reference">删除<i
                class="el-icon-remove-outline"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!--分页部分-->
    <div class="pd-10">
      <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :page-sizes="[10, 15, 20, 50]"
          :current-page="send.currentPage"
          :page-size="send.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="send.total">
      </el-pagination>
    </div>

    <!--新增或修改弹窗-->
    <el-dialog title="角色信息" :visible.sync="sendFormFlag" :close-on-click-modal="false">
      <el-form label-width="120px" size="small">
        <el-form-item label="名称">
          <el-input v-model="sendForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="sendForm.des" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmInsertOrUpdate">确 定</el-button>
        <el-button @click="sendFormFlag = false">取 消</el-button>
      </div>
    </el-dialog>

    <!--分配菜单弹框-->
    <el-dialog title="菜单分配" :visible.sync="roleGiveFlag" :close-on-click-modal="false" width="30%">
      <!--树形控件   :default-expanded-keys="role.expandList"与  :default-expand-all="true"用一个即可-->
      <el-tree
          ref="tree"
          :props="send.props"
          :data="send.data"
          show-checkbox
          node-key="id"
          :default-expand-all="true"
          :default-checked-keys="menuIdList"
          @check-change="onCheckChange">
        <!--展示带icon的图标+内容-->
        <template class="" slot-scope="{node,data}">
          <span><i :class="data.icon"></i> {{ data.name }}</span>
        </template>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmInsertOrUpdate">确 定</el-button>
        <el-button @click="roleGiveFlag = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import myVuex from "@/js_store/myVuex";
import {WHITE_IP} from "../../public/config";
import router from "@/js_router/router";

export default {
  name: "Role",
  data() {
    return {
      WHITE_IP: WHITE_IP,
      headerBg: 'headerBg',
      list: [], // 该页面主列表
      menuIdList: [],// 拥有的菜单列表
      roleGiveFlag: false, // 菜单分配是否展示
      send: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        name: '',
        des: '',
        data: [], //动态赋值
        props: {
          label: "name" // 这样绑定菜单名称
        }
      },
      sendForm: {}, // 新增菜单
      sendFormFlag: false, // 是否展示角色新增菜单
    }
  },
  //------------------------
  created() {
    // 请求分页数据
    this.selectListPage()
  },
  methods: {
    hIndex(index) {
      // 当前页数 - 1 * 每页数据条数 + index + 1 （ index 是索引值，从0开始）
      return (this.send.currentPage - 1) * this.send.pageSize + index + 1
    },
    /*当菜单勾选发生变化时*/
    onCheckChange() {
      // console.log(this.$refs.tree.getCheckedKeys());
      //  JSON.stringify(this.$refs.tree.getCheckedKeys());
    },
    /*分配菜单*/
    giveMenu(row) {
      this.sendForm.id = row.id; // 为了分配菜单用的
      this.sendForm.name = row.name
      this.$http.post("/role/select", this.sendForm).then(res => {
        // alert(JSON.stringify(res))
        this.menuIdList = res.data.object.menuIdList  // 每次点击都会根据id查询
        // console.log(this.role.menuIds)
      })
      // 请求menu数据
      this.$http.post("/menu/list_all", {}).then(res => {
        // alert(JSON.stringify(res.data.object))
        this.send.data = res.data.object
        // 处理成id数组
        /*this.role.expandList = this.role.data.map(temp => temp.id)*/
      })
      this.roleGiveFlag = true

    },
    /*导入成功*/
    onImportSuccess() {
      this.$message.success("文件导入成功")
      this.selectListPage()
    },
    /*导出*/
    list_export() {
      window.open(`https://${WHITE_IP}/role/list_export`)
    },
    /*重置函数*/
    reset() {
      this.send.name = ''
      this.send.des = ''
      this.selectListPage()
    },
    /*当前页变化时*/
    onCurrentChange(currentPage) {
      // console.log(currentPage)
      this.send.currentPage = currentPage
      this.selectListPage()
    },
    /*每页条数变化时*/
    onSizeChange(pageSize) {
      this.send.pageSize = pageSize
      this.selectListPage()
    },
    /*分页查询*/
    selectListPage() {
      // console.log("---" + JSON.stringify(this.role))
      this.$http.post("/role/list_page", this.send).then(res => {
        if (res.data.code === "200") {
          this.send.total = res.data.object.total
          this.list = res.data.object.data
        } else {
          this.$message.error('查询失败，' + res.data.code)
          router.push("/login")
        }
      })
    },
    /*复选框变化时*/
    onSelectChange(val) {
      this.sendForm.removeIdList = val
    },
    /*确认批量删除*/
    confirmRemoveIdList() {
      if (this.sendForm.removeIdList === undefined) {
        return
      }
      this.sendForm.removeIdList = this.sendForm.removeIdList.map(v => v.id)  // [{},{},{}] =>[1,2,3]
      this.$http.post("role/list_delete", this.sendForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('批量删除成功')
        } else {
          this.$message.error('批量删除失败，' + res.data.message)
        }
        this.selectListPage()
      })
    },
    /*确认删除*/
    confirmDelete(id) {
      this.sendForm.id = id
      // alert(this.sendForm.id)
      this.$http.post("/role/delete", this.sendForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败，' + res.data.message)
        }
        this.selectListPage()
      })
    },
    /*修改窗口*/
    updateWindow(row) {
      this.sendFormFlag = true
      this.sendForm = JSON.parse(JSON.stringify(row))
    },
    /*确认新增或修改*/
    confirmInsertOrUpdate() {
      this.sendFormFlag = false
      this.roleGiveFlag = false
      // alert(JSON.stringify(this.$refs.tree.getCheckedKeys()))
      // 只有修改的时候才需要指定属性menuIds 其他的时候不需要
      if (this.$refs.tree !== undefined && this.sendForm.id !== undefined) {
        this.sendForm.menuIds = JSON.stringify(this.$refs.tree.getCheckedKeys()); // 分配角色拥有的菜单
      }
      this.$http.post("/role/insertOrUpdate", this.sendForm).then(res => {
        if (res.data.code === "200") {
          this.$message.success('保存成功')
          if (this.$refs.tree !== undefined && this.sendForm.id !== undefined) {
            if (this.sendForm.name === "管理员") {
              myVuex.commit("userLogout")
            }
          }
        } else {
          this.$message.error("保存失败，" + res.data.message)
        }
        this.selectListPage()
      })
    },
    /*新增窗口*/
    insertWindow() {
      this.sendFormFlag = true
      this.sendForm = {} // 初始化新增空白表单
    },
  }
}
</script>

<style scoped>
</style>
